<template>
  <Adsense
    :data-ad-slot="dataAdSlot"
    data-ad-format="rectangle"
    style="display:inline-block;width:300px;height:250px"
  ></Adsense>
</template>

<script>
import Adsense from './Adsense'

export default {
  components: {
    Adsense
  },

  props: {
    dataAdSlot: {
      type: String,
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdsenseRect.vue